<template>
  <span class="fav-btn" @click="handleFav">
    <slot></slot>
  </span>
</template>

<script>
export default {
  props: {
    isFav: [Boolean, Number],
    id: [Number, String],
  },

  methods: {
    async handleFav() {
      if (!this.$store.state.user.userInfo) {
        this.$eventBus.$emit('login', 'fav');
        return;
      }

      try {
        let res;
        if (this.isFav) {
          res = await this.$service.learning.doUnFav(this.id);
        } else {
          res = await this.$service.learning.doFav(this.id);
        }

        if (res.code === 200) {
          this.$toast(`${this.isFav ? '取消' : ''}收藏成功`, 'iconic_success');
          this.$emit('change', this.isFav ? 0 : 1);
        } else {
          this.$toast(res.msg);
        }
      } catch (err) {
        this.$toast('未知错误，请重试');
      }
    },
  },
};
</script>